export default __webpack_public_path__ + "static/media/seed-tag.4a8276d6.jpg";